"use strict";

exports.__esModule = true;
exports["default"] = Weibo;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Weibo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    preserveAspectRatio: "xMinYMin meet",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.5 333.6c0 59.4 77.3 107.5 172.6 107.5s172.6-48.2 172.6-107.5-77.3-107.5-172.6-107.5S38.5 274.2 38.5 333.6",
    fill: "#FFF"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M215.2 432.4c-84.4 8.3-157.3-29.8-162.8-85.2-5.5-55.4 58.6-107.1 142.9-115.5 84.4-8.3 157.3 29.8 162.7 85.2 5.6 55.5-58.4 107.2-142.8 115.5m168.8-184c-7.2-2.2-12.1-3.6-8.3-13 8.2-20.5 9-38.2.2-50.8-16.5-23.7-61.8-22.4-113.8-.7 0 0-16.3 7.1-12.1-5.7 7.9-25.7 6.7-47.2-5.7-59.6-28.2-28.2-103.1 1.1-167.3 65.3-48.1 48-76 99-76 143.2 0 84.3 108.2 135.6 213.9 135.6 138.7 0 231-80.6 231-144.6.1-38.7-32.5-60.7-61.9-69.7",
    fill: "#E51D2E"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M476.2 94.1C442.7 57 393.3 42.8 347.7 52.5c-10.6 2.2-17.2 12.7-15 23.2 2.2 10.6 12.6 17.2 23.2 15 32.4-6.9 67.6 3.2 91.3 29.6s30.2 62.3 20.1 93.9c-3.3 10.2 2.3 21.2 12.6 24.6 10.2 3.3 21.2-2.3 24.6-12.5v-.1c14.3-44.4 5.2-95-28.3-132.1",
    fill: "#F89939"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M424.8 140.5c-16.3-18.1-40.4-25-62.6-20.2-9.1 1.9-14.8 10.9-12.9 20 2 9.1 10.9 14.8 19.9 12.9 10.8-2.3 22.7 1.1 30.6 9.8 7.9 8.8 10.2 20.9 6.7 31.4-2.8 8.8 2 18.3 10.8 21.2 8.8 2.8 18.3-2 21.2-10.8 7-21.5 2.5-46.2-13.7-64.3",
    fill: "#F89939"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M219.9 332.1c-2.9 5.1-9.5 7.5-14.6 5.3-5.1-2-6.6-7.7-3.7-12.7 2.9-4.9 9.2-7.3 14.2-5.3 5.1 1.9 6.9 7.5 4.1 12.7M193 366.5c-8.2 13-25.7 18.7-38.8 12.7-12.9-5.9-16.8-21.1-8.7-33.7 8.1-12.7 25-18.3 38.1-12.8 13.1 5.7 17.4 20.7 9.4 33.8m30.6-92.2c-40.2-10.5-85.6 9.6-103 45-17.8 36.1-.6 76.2 40 89.3 42.1 13.6 91.7-7.2 108.8-46.2 17.1-38.1-4.2-77.3-45.8-88.1",
    fill: "#010101"
  }));
}